const systemPrompts = [
  {
    id: "1",
    icon: "🕔",
    title: "Experiences/Trip management"
  },
  {
    id: "2",
    icon: "⭐️",
    title: "Booking management"
  },
  {
    id: "3",
    icon: "🗓",
    title: "Calendar availability"
  },
  {
    id: "4",
    icon: "💲",
    title: "My business statistic"
  }
]
export { systemPrompts }
